import { Component } from '@angular/core';
import { CityParkingStampListPayload, CityParkingStampListByIdResponse, ExecuteCityparkingStampList } from '../../../../core/models/stamp.model';
import { InputComponent } from "../../../../tools/forms/input/input.component";
import { CommonModule } from '@angular/common';
import { Providers } from '../../../../core/models/information.model';
import { MyVehicleAllResponse } from '../../../../core/models/user.model';
import { FormsModule } from '@angular/forms';
import { ApiService } from '../../../../core/services/api.service';
import { SelectComponent } from "../../../../tools/forms/select/select.component";
import { ToastNotifService } from '../../../../core/services/toast-notif.service';
import * as XLSX from 'xlsx';
import { CookieService } from 'ngx-cookie-service';
import { ActivatedRoute } from '@angular/router';
import { ApiHandlerService } from '../../../../tools/services/api/handler-api/apiHandler.service';
import { ActionApiResponse } from '../../../../core/models/card.model';
import { CheckboxComponent } from "../../../../tools/forms/checkbox/checkbox.component";
import { ClientIInfo } from '../../../../core/models/parking.model';
import { ToastService } from 'angular-toastify';
import { ApiFormService } from '../../../../core/services/api-form.service';
import { ModalProviderSiteComponent } from "../../modals/other/modal-provider-site/modal-provider-site.component";
import { ModalAdminActivityHistoryComponent } from '../../modals/system-settings/modal-admin-activity-history/modal-admin-activity-history.component';
import { AdminActivityEntityTypes } from '../../../../core/models/system-settings/admin-activity-log.model';

@Component({
  selector: 'app-stamp-discount-details',
  imports: [
    InputComponent,
    CommonModule,
    FormsModule,
    SelectComponent,
    CheckboxComponent,
    ModalProviderSiteComponent,
    ModalAdminActivityHistoryComponent,
  ],
  templateUrl: './stamp-discount-details.component.html',
  styleUrl: './stamp-discount-details.component.css'
})
export class StampDiscountDetailsComponent {
  // URL 
  urlDiscountCardId: string | null = null;

  // User
  userId: number | null = null;

  // Cityparking Stamp List 
  cityparkingStampListPayload: CityParkingStampListPayload | null = null;
  cityparkingStampListByIdResponse: CityParkingStampListByIdResponse | null = null;

  // (Value)
  siteName: string = '';
  name: string = '';
  token: string = '';
  stampLimitDay: number = 0;
  stampLimitMonth: number = 0;
  limitDay: boolean = false;
  limitMonth: boolean = false;
  startDate: Date | null = null;
  endDate: Date | null = null;
  expireDate: boolean = false;
  stampType: boolean = false;
  online: boolean = false;
  status: number = 1;
  remark: string = '';

  // (Site)
  allProviders: Providers[] = [];
  siteId: number | null = null;
  CardOptions: {
    value: number;
    label: string;
    fig_day: number;
    vehicle_type_name: string;
    subscription_id: number;
  }[] = [];
  carFilteredPlateList: MyVehicleAllResponse[] = [];
  selectCarPlate: MyVehicleAllResponse[] = [];
  selectedCar: string | null = null;

  // (Client)
  selectClient: { name: string, value: any } = { name: '', value: '' };
  optionClient: { name: string, value: any }[] = [];


  // (Rate)
  selectRate: { name: string; value: any } = { name: '', value: '' };
  rateOptions: { name: string; value: any }[] = [
  ];


  // Modal
  showSelectProviderModal: boolean = false;
  showConfirmModal: boolean = false;
  showModalSite: boolean = true

  readonly activityEntityTypes = AdminActivityEntityTypes;
  showActivityHistory = false;

  // Security
  isDisableInput: boolean = false;
  isLoading: boolean = false;
  isValidateText: { where: string, result: boolean } = { where: '', result: false }
  isValidateNumber: { where: string, result: boolean } = { where: '', result: false }
  isValidateTextNumber: { where: string, result: boolean } = { where: '', result: false }


  constructor(
    private apiHandler: ApiHandlerService,
    private apiService: ApiService,
    private apiFormService: ApiFormService,
    private toast: ToastService,
    private cookieService: CookieService,
    private route: ActivatedRoute
  ) { }
  ngOnInit(): void {
    // Default
    this.getProviders();
    this.userId = parseInt(this.cookieService.get('user_id'));

    // Cityparking Discount Details
    // อ่าน param id จาก route
    this.route.paramMap.subscribe((params) => {
      this.urlDiscountCardId = params.get('id');
      //console.log('Current Url ID:', this.urlDiscountCardId);

      if (this.urlDiscountCardId) {
        this.isDisableInput = true;

        this.getCityparkingStampListByIdResponse(this.urlDiscountCardId);
      }
    });



  }

  /* -------------------------------- Function -----------------------------------------*/
  /* ---- style ---- */
  onChangeStampLimitDay(option: any) {
    this.stampLimitDay = option.result;
    //console.log('stampLimitDay', this.stampLimitDay);
  }
  onChangeStampLimitMonth(option: any) {
    this.stampLimitMonth = option.result;
    //console.log('stampLimitMonth', this.stampLimitMonth);
  }
  onChangeStampLimitExpireDate(option: any) {
    this.expireDate = option.result;
  }
  onChangeOnline(option: any) {
    this.online = option.result;
  }


  /* ---- Function ---- */

  selectProvider(provider: any) {
    this.showSelectProviderModal = false;
    this.siteId = provider.id;
    this.siteName = provider.name;

    //console.log('Site ID', this.siteId);
    setTimeout(() => {
      this.carFilteredPlateList = [];
      this.selectCarPlate = [];
      this.getClientInfo(this.siteId ?? 0);
      this.getApiCityparkingStampRate(this.siteId ?? 0);
    }, 200);
  }

  /* ---- Client ----*/
  onChangeSelectClient(option: { name: string; value: any }) {
    this.selectClient = option;
  }
  /* ---- Rate ----*/
  onChangeSelectRate(option: { name: string; value: number }) {
    this.selectRate = option;
  }

  /* ---- Generate Code ----*/
  onClickGenerateCode() {
    const body: ExecuteCityparkingStampList = {
      uid: this.userId ?? 0,
      id: Number(this.urlDiscountCardId) ?? 0,
      remark: this.remark
    }
    this.sentApiExecuteCityParkingStampList(body)
  }
  // ( Clear )
  onClearGenerateCode() {
    this.remark = '';
  }

  /* ---- Cityparking Discount Details ----*/
  onSetValueCityparkingStampListByIdResponse() {
    this.siteId = this.cityparkingStampListByIdResponse?.siteId ?? 0;
    this.siteName = this.cityparkingStampListByIdResponse?.siteName ?? '';
    this.token = this.cityparkingStampListByIdResponse?.token ?? '';

    this.name = this.cityparkingStampListByIdResponse?.name ?? '';
    this.stampLimitDay = this.cityparkingStampListByIdResponse?.stampLimitDay ?? 0;
    this.stampLimitMonth = this.cityparkingStampListByIdResponse?.stampLimitMonth ?? 0;
    this.limitDay = this.cityparkingStampListByIdResponse?.limitDay ?? false;
    this.limitMonth = this.cityparkingStampListByIdResponse?.limitMonth ?? false;
    this.startDate = this.cityparkingStampListByIdResponse?.startDate ?? null;
    this.endDate = this.cityparkingStampListByIdResponse?.endDate ?? null;
    this.status = this.cityparkingStampListByIdResponse?.status ?? 0;
    this.remark = this.cityparkingStampListByIdResponse?.remark ?? '';

    this.selectClient = this.optionClient.find((client) =>
      client.value == this.cityparkingStampListByIdResponse?.clientId
    ) ?? { name: '', value: 0 };

    this.selectRate = this.rateOptions.find((rate) =>
      rate.value == this.cityparkingStampListByIdResponse?.rateId
    ) ?? { name: '', value: 0 };
  }


  /* --- Table --- */
  // ( Copy )
  onClickCopyCode(code: string) {
    navigator.clipboard.writeText(code).then(() => {
      this.toast.success('คัดลอกเรียบร้อย');
      return;
    });
  }
  // ( Excel )
  onExportToExcel() {
    const headersCityparkingStampListByIdResponseDetail = [
      'id',
      'name',
      'code',
      'activate',
      'status',
      'createDate',
      'activateDate',
      'maxUsage',
      'usageCount',
    ];

    // รวม headers + sample data
    // Ensure we pass an array to json_to_sheet: if the response is already an array use it,
    // if it's a single object wrap it in an array, and if it's null/undefined use an empty array.
    const data: any[] = Array.isArray(this.cityparkingStampListByIdResponse)
      ? this.cityparkingStampListByIdResponse
      : this.cityparkingStampListByIdResponse
        ? [this.cityparkingStampListByIdResponse]
        : [];

    const worksheet = XLSX.utils.json_to_sheet(data, {
      header: headersCityparkingStampListByIdResponseDetail,
    });
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, 'Template');

    XLSX.writeFile(workbook, 'CityparkingDiscount_Template.xlsx');
  }

  /* ---- Cityparking Discount Payload ----*/
  onClickSaveCityparkingStampList() {
    // ตรวจสอบความถูกต้องข้อมูล
    if (!this.onValidateCityparkingStampListPayload()) return;
    // ใส่ค่าข้อมูล
    this.onSetValueCityparkingStampListPayload();
    // ส่ง API
    this.sentApiCityparkingStampListPayload();
  }
  // ( Validate )
  onValidateCityparkingStampListPayload() {
    const today = new Date();

    today.setHours(0, 0, 0, 0);
    if (!this.siteId) {
      alert('กรุณาเลือก Site');
      return false;
    } else if (this.siteId <= 0) {
      alert('กรุณาเลือก Site');
      return false;
    } else if (this.name == '') {
      alert('กรุณากรอกชื่อ');
      return false;
    } else if (this.selectClient) {
      if (this.selectClient.value <= 0) {
        alert('กรุณาเลือกลูกค้า');
        return false;
      }
    } else if (this.selectRate) {
      if (this.selectRate.value <= 0) {
        alert('กรุณาเลือกเรทที่ถูกต้อง');
        return false;
      }
    } else if (this.limitDay) {
      if (this.stampLimitDay <= 0) {
        alert('กรุณากรอกจํานวนวัน');
        return false;
      }
    } else if (this.limitMonth) {
      if (this.stampLimitMonth <= 0) {
        alert('กรุณากรอกจํานวนเดือน');
        return false;
      }
    }
    else if (!this.startDate) {
      alert('กรุณาเลือกวันเริ่ม');
      return false;
    } else if (this.expireDate) {
      if (!this.endDate) {
        alert('กรุณาเลือกวันสิ้นสุด');
        return false;
      }
      else if (this.endDate <= this.startDate) {
        alert('วันสิ้นสุดต้องมากกว่าวันเริ่ม');
        return false;
      }
    } else if (this.startDate < today) {
      alert('วันเริ่มต้องไม่ก่อนวันปัจจุบัน');
      return false;
    }
    return true
  }
  // ( Set Value )
  onSetValueCityparkingStampListPayload() {
    this.cityparkingStampListPayload = {
      name: this.name,
      token: this.token,
      siteId: this.siteId ?? 0,
      clientId: this.selectClient.value,
      rateId: this.selectRate.value,
      stampLimitDay: this.stampLimitDay,
      stampLimitMonth: this.stampLimitMonth,
      limitDay: this.limitDay,
      limitMonth: this.limitMonth,
      expireDate: this.expireDate,
      startDate: this.startDate,
      endDate: this.endDate,
      stampType: this.stampType,
      remark: this.remark,
      online: this.online,
      userId: this.userId,
    };
  }
  // ( Clear )
  onClearCityparkingStampListPayload() {
    // ล้าง payload
    this.cityparkingStampListPayload = {
      name: '',
      token: '',
      siteId: 0,
      clientId: 0,
      rateId: 0,
      stampLimitDay: 0,
      stampLimitMonth: 0,
      limitDay: false,
      limitMonth: false,
      expireDate: false,
      startDate: null,
      endDate: null,
      stampType: false,
      remark: '',
      online: false,
      userId: 0
    }

    // ล้างข้อมูล Input
    this.siteId = 0;
    this.siteName = '';
    this.selectRate = { name: '', value: 0 };
    this.selectClient = { name: '', value: 0 };
    this.name = '';
    this.stampLimitDay = 0;
    this.stampLimitMonth = 0;
    this.limitDay = false;
    this.limitMonth = false;
    this.startDate = null;
    this.endDate = null;
    this.expireDate = false;
    this.stampType = false;
    this.online = false;
    this.status = 1;
    this.remark = '';

    this.optionClient = [];
    this.rateOptions = [];
  }
  /* -------------------------------- API -----------------------------------------*/

  /* --- Default --- */
  getProviders() {
    this.apiHandler.handleApi(
      this.apiFormService.getProviders(),
      {
        logLabel: 'getProvider',
        isConsoleLog: true,
        loading: (loading: boolean) => this.isLoading = loading,
        success: (response: any) => {
          this.allProviders = response;
        },
      }
    );
  }
  getClientInfo(site_id: number) {
    this.apiService.GetClientIInfo(site_id).subscribe({
      next: (response: ClientIInfo[]) => {
        //console.log('📦 ClientIInfo', response);
        // สร้างค่าสำหรับใส่ select template
        const clientList: { name: string, value: any }[] = []
        response.map((client) => {
          clientList.push({
            value: client.id,
            name: client.name
          })
        });
        this.optionClient = clientList;
      },
      error: (error) => {
        console.error('API error:', error);
      },
    });
  }
  getApiCityparkingStampRate(siteId: number) {
    this.apiHandler.handleApi(
      this.apiService.getApiCityparkingStampRate(siteId),
      {
        logLabel: 'getStampRate',
        isConsoleLog: true,
        loading: (loading: boolean) => this.isLoading = loading,
        success: (response: any) => {
          this.rateOptions = response;
        }
      }
    )
  }
  /* --- Cityparking Stamp Discount Details --- */
  getCityparkingStampListByIdResponse(id: string) {
    this.apiHandler.handleApi(
      this.apiService.getCityparkingStampListByIdResponse(id),
      {
        logLabel: 'getCityparkingStampListByIdResponse',
        isConsoleLog: true,
        loading: (loading: boolean) => this.isLoading = loading,
        success: (response: CityParkingStampListByIdResponse) => {
          this.cityparkingStampListByIdResponse = response;
          this.onSetValueCityparkingStampListByIdResponse();
        },
      }
    );
  }



  /* --- Cityparking Stamp Discount Payload --- */
  sentApiCityparkingStampListPayload() {
    if (!this.cityparkingStampListPayload) return;

    this.apiHandler.handleApi(
      this.apiService.sentApiCityparkingStampListPayload(this.cityparkingStampListPayload),
      {
        logLabel: 'sentApiCityparkingDiscount',
        isConsoleLog: true,
        loading: (loading: boolean) => this.isLoading = loading,
        success: () => {
          this.toast.success('สร้างรหัสเรียบร้อย');
          this.onClearCityparkingStampListPayload();
          if (this.urlDiscountCardId) {
            this.getCityparkingStampListByIdResponse(this.urlDiscountCardId);
          }
        },
      }
    );
  }

  /* --- Generate Code --- */
  sentApiExecuteCityParkingStampList(body: ExecuteCityparkingStampList) {
    this.apiHandler.handleApi(
      this.apiService.sentApiExecuteCityParkingStampList(body),
      {
        logLabel: 'sentApiExecuteCityParkingStampList',
        isConsoleLog: true,
        loading: (loading: boolean) => this.isLoading = loading,
        success: (response: ActionApiResponse) => {
          this.toast.success(`สร้างรหัสเรียบร้อย\n${response.message}`);
          this.onClearGenerateCode();
          if (this.urlDiscountCardId) {
            this.getCityparkingStampListByIdResponse(this.urlDiscountCardId);
          }
        },
        error: () => {
          this.toast.error('สร้างรหัสล้มเหลว');
        },
      }
    );
  }

  get stampListEntityId(): number {
    return Number(this.urlDiscountCardId) || 0;
  }

  get canShowActivityHistory(): boolean {
    return this.stampListEntityId > 0;
  }

  openActivityHistory(): void {
    if (!this.canShowActivityHistory) return;
    this.showActivityHistory = true;
  }

  closeActivityHistory(): void {
    this.showActivityHistory = false;
  }

}

